import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div>
        Calculations per ISO 9613-2. For screening purposes only.
      </div>
      <div className="footer-links">
        &copy; {new Date().getFullYear()} Franc Engineering | <a href="https://franceng.com" target="_blank" rel="noopener noreferrer">franceng.com</a>
      </div>
    </footer>
  );
}

export default Footer;
